import { Stack, Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Flex, FlexBetween, FlexColumn, FlexStart, themeValue } from 'styles'
import { ReactComponent as SvgELipse } from 'assets/account/ellipse.svg'

export const AccountWrap = styled(Stack)`
  cursor: default;
`
export const Popup = styled('div')`
  width: 360px;
  box-sizing: border-box;
  padding: 8px 16px 24px;
  overflow: hidden;
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border-radius: 0px 0px 6px 6px;
  z-index: 99;

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(22, 25, 30, 1);
    padding: 0;
  }
`

export const AccountHeader = styled(FlexBetween)`
  border-bottom: 1px solid;
  height: 56px;
  padding: 12px 0px;
  box-sizing: border-box;
  border-bottom-color: ${({ theme }) => theme.color.bg2};

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 12px 8px;
    margin: 0 16px;
  }
`
export const StyledSvgELipse = styled(SvgELipse)`
  width: 16px;
  height: 16px;
`

export const StyledAddress = styled('span')`
  margin-right: 5px;
  display: inline-block;
  margin-left: 4px;
  color: ${({ theme }) => theme.color.text60};
  font-size: 16px;
`

export const StyledBody = styled(FlexColumn)`
  padding-top: 24px;
  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 24px 16px 0;
  }
`

export const BtnWrap = styled(Stack)``

export const StyledButton = styled(Button)`
  height: 32px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: rgba(42, 49, 57, 1);
  &:hover {
    font-weight: 600;
    background: rgba(57, 65, 73, 1);
    color: rgba(160, 238, 9, 1);
  }
`
export const DepositButton = styled(StyledButton)`
  flex: 1;
  margin-left: 0px;
  border-radius: 16px;
`

export const AccountOperate = styled(Flex)``

export const IconRectWrap = styled('div')`
  position: relative;

  .tip {
    position: absolute;
    top: -20px;
    color: #e5eaee;
    font-family: 'Source Sans Pro';
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
  }
`

export const IconRect = styled(Flex)`
  /* background-color: rgba(57, 65, 73, 1); */
  border-radius: 4px;
  align-items: center;
  width: 32px;
  height: 32px;
  box-sizing: border-box;
  margin-right: 8px;

  &:last-child {
    margin-right: 0px;
  }

  svg {
    color: rgba(149, 164, 173, 1) !important;
  }

  &:hover {
    color: ${({ theme }) => theme.color.text80};
    background-color: rgba(57, 65, 73, 1);
    /* border-color: ${({ theme }) => theme.palette.primary.main}; */
    cursor: pointer;
    svg {
      color: ${({ theme }) => theme.palette.primary.main} !important;
    }
  }
`

export const TabWrap = styled(FlexStart)`
  margin-top: 24px;
  /* gap: 0 18px; */
`

export const TabText = styled('span')`
  font-size: 16px;
  /* color: ${(props) => props.theme.color.text40}; */
  padding-bottom: 6px;
  color: rgba(149, 164, 173, 1);

  &.active {
    color: ${(props) => props.theme.color.text100};
    /* border-width: 20%; */
    position: relative;

    &::after {
      content: '';
      position: absolute;
      width: 16px;
      height: 10px;
      display: block;
      margin: 0 auto;
      left: 50%;
      transform: translate(-50%, 0);
      border-bottom: 2px solid ${(props) => props.theme.color.text100};
    }
  }
  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.color.text100};
  }
`

export const AssetsItem = styled(FlexBetween)`
  /* margin-bottom: 8px; */
  height: 32px;
  font-size: 14px;
  padding: 8px 8px;
  box-sizing: border-box;
  &:hover {
    background-color: rgba(42, 49, 57, 1);
    border-radius: 4px;
  }
`
export const AssetsBorderLine = styled('div')`
  width: 100%;
  margin: 12px 0px;
  height: 1px;
  background-color: ${({ theme }) => theme.color.bg2};
`

export const AssetsItemTitle = styled(Flex)`
  color: ${(props) => props.theme.color.text40};
  align-items: center;
  cursor: pointer;
  svg {
    margin-right: 4px;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    color: rgba(149, 164, 173, 1);

    svg {
      display: none;
    }
  }
`

export const ItemValue = styled(Flex)`
  color: ${(props) => props.theme.color.text80};
  font-weight: 600;
  font-size: 14px;
`

export const PinupTexrt = styled('p')`
  color: rgba(245, 69, 93, 1);
  font-size: 14px;
  text-align: left;
  margin-top: 0px;
  margin-bottom: 0px;
`

export const HelpBoxWrap = styled(FlexColumn)`
  padding: 8px 12px;
  border-bottom: 1px solid;
  border-bottom-color: ${({ theme }) => theme.color.bg2};
  background-color: ${({ theme }) => theme.color.bg};
  border-radius: 4px;
  justify-content: flex-start;
`

export const QAHelpTitle = styled('span')`
  color: ${({ theme }) => theme.color.text80};
  font-weight: 600;
`

export const QAHelpDescBox = styled('div')`
  align-items: flex-start;
  display: flex;
  margin-top: 4px;
  span {
    color: ${({ theme }) => theme.color.text40};
    font-size: 14px;
  }

  svg {
    width: 20px;
    height: 20px;
    flex-basis: 20px;
    flex-shrink: 0;
  }
`

export const ContentWrap = styled(Stack)`
  margin-top: 24px;
  justify-content: space-between;
  min-height: 410px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    justify-content: flex-start;
  }
`

export const HistoryTab = styled(FlexBetween)`
  padding: 6px 12px 6px 15px;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 8px;
  font-size: 14px;
  border-radius: 4px;
  height: 40px;
  font-weight: 400;
  color: ${({ theme }) => theme.color.text70};
  /* background: ${({ theme }) => theme.color.bg2}; */
  background-color: #2a3139;
  border-left: 3px solid transparent;
  overflow: hidden;
  svg {
    display: none;
  }

  &:hover {
    color: rgba(160, 238, 9, 1);
    /* border-color: ${({ theme }) => theme.palette.primary.main}; */
    cursor: pointer;
    svg {
      display: block;
    }
    border-left: 3px solid rgba(160, 238, 9, 1);
  }
`

export const PortfolioWrap = styled(Flex)`
  padding: 12px 16px;
  background-color: rgba(22, 25, 30, 1);
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  line-height: 20px;
  .left {
    display: flex;
    width: 188px;
    flex-direction: column;

    .title {
      color: #fff;
      font-size: 14px;
      font-weight: 600;
      margin: 0;
    }
    .desc {
      color: #95a4ad;
      font-size: 12px;
      font-weight: 400;
      padding: 0;
      margin: 12px 0 0;
    }
  }

  svg {
    transform: rotate(-45deg);
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    background-color: rgba(30, 35, 41, 1);
  }
`
